<template>
  <div class="moreBtn">
    <Button :loading="anLoading" @click="viewMore" :disabled="isForbid">{{ moreTxt }}</Button>
  </div>
</template>
<script>
import { getRequest } from '@/libs/axios'
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    searchForm: {
      type: Object,
      default: null
    },
    list: {
      type: Array,
      default: null
    },
    toggleId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isForbid: false,
      moreTxt: '加载更多',
      totalLength: 0,
      postList: [],
      anLoading: false
    }
  },
  watch: {
    toggleId() {
      if (this.toggleId) {
        this.postList = []
        this.isForbid = false
        this.moreTxt = '加载更多'
        this.anLoading = false
      }
    }
  },
  methods: {
    async viewMore() {
      // 如果切换了栏目清空之前的数据
      if (this.toggleId) {
        this.postList = []
      }
      this.anLoading = true
      this.moreTxt = '加载中...'
      this.searchForm.pageNumber += 1
      const res = await getRequest(this.url, this.searchForm, false)
      this.anLoading = false
      this.moreTxt = '加载更多'
      if (res.success) {
        this.postList = this.postList.concat(res.result.list)
        this.totalLength = res.result.total
        this.$emit('changeList', this.postList)
      }
      if (parseInt(this.postList.length + this.list.length) >= this.totalLength) {
        this.moreTxt = '没有更多数据了~'
        this.isForbid = true
      } else {
        this.moreTxt = '加载更多'
        this.isForbid = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.moreBtn {
  width: 80%;
  margin: 0.5rem auto 0.2rem;
  .ivu-btn {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/components/loadingMore.vue